export const AllowsPayload = {
    POST: true,
    PUT: true,
    DELETE: true,
};
//# sourceMappingURL=allows_payload.js.map